import { GET, GET_PROPOSALS, GET_PERMISSIONS } from "app/topics/constants";
import { ADD, ON_SUBMIT } from "app/proposals/constants";
import {
  queryProposals,
  queryDrafts,
  fetchProposalPermissions
} from "app/proposals/actions";
import {
  setProposals,
  setDrafts,
  addProposal,
  removeProposal
} from "app/topics/actions";
import { fetchTopicPermissions } from "./actions";

const _setProposals = action => {
  const {
    data,
    payload: {
      params: { topicId }
    }
  } = action;
  return setProposals({ topicId, proposals: data });
};

const _setDrafts = action => {
  const {
    data,
    payload: {
      params: { topicId }
    }
  } = action;
  return setDrafts({ topicId, drafts: data });
};

export const topicFlowMiddleware = store => next => action => {
  let result = next(action);
  const { getState, dispatch } = store;
  const state = getState();
  let topicId, proposalId;
  switch (action.type) {
    case GET.SUCCESS:
      topicId = action.data._id;
      if (state.auth.isAuthenticated) {
        dispatch(
          queryProposals({ topicId }, [_setProposals, fetchTopicPermissions])
        );
        dispatch(queryDrafts({ topicId }, [_setDrafts]));
      } else {
        dispatch(queryProposals({ topicId }, [_setProposals]));
      }
      break;
    case GET_PROPOSALS:
      topicId = action.topicId;
      if (state.auth.isAuthenticated) {
        dispatch(
          queryProposals({ topicId }, [_setProposals, fetchTopicPermissions])
        );
        dispatch(queryDrafts({ topicId }, [_setDrafts]));
      } else {
        dispatch(queryProposals({ topicId }, [_setProposals]));
      }
      break;
    case GET_PERMISSIONS:
      topicId = action.topicId;
      const { proposals } = action;
      proposals.forEach(proposal => {
        const proposalId = proposal._id;
        dispatch(fetchProposalPermissions({ proposalId, permission: "read" }));
        dispatch(
          fetchProposalPermissions({ proposalId, permission: "delete" })
        );
      });
      break;
    case ADD.SUCCESS:
      topicId = action.data.topicId;
      proposalId = action.data._id;
      dispatch(addProposal({ topicId, proposalId }));
      break;
    case ON_SUBMIT.SUCCESS:
      topicId = action.data.topicId;
      proposalId = action.data._id;
      const draftId = action.data.draftId;
      dispatch(removeProposal({ topicId, proposalId: draftId }));
      dispatch(addProposal({ topicId, proposalId }));
      break;
    default:
      return result;
  }
};



// WEBPACK FOOTER //
// ./src/app/topics/middleware.js